import React from 'react';
import { useClassName } from 'common/hooks';
import './social-block.less';
import { getContentfulField } from 'common/components';
import { ParkMoments } from './ParkMoments/ParkMoments';
import { SlideIntoFun } from './SlideIntoFun/SlideIntoFun';

export const SocialBlock = ({ venue }) => {
  const className = useClassName('SocialBlock');
  const mainColor = getContentfulField(venue.parkScreen?.mainColor);
  const tertiaryColor = getContentfulField(venue.parkScreen?.tertiaryColor);

  return (
    <div
      className={className('container')}
      style={{
        background: `linear-gradient(180deg, ${tertiaryColor} 0%, white 100%)`,
      }}>
      <div
        className={className('container__wrapper')}
        style={{ backgroundColor: mainColor }}>
        <div className={className('container__inner')}>
          <ParkMoments venue={venue} />

          <SlideIntoFun venue={venue} />
        </div>
      </div>
    </div>
  );
};
